function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4382 10.9378C13.0932 10.9378 12.8129 10.6584 12.8129 10.3125V9.68718C12.8129 9.34218 13.0932 9.06187 13.4382 9.06187C13.7832 9.06187 14.0626 9.34218 14.0626 9.68718V10.3125C14.0626 10.6575 13.7832 10.9378 13.4382 10.9378Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6254 10.9378C15.465 10.9378 15.3057 10.8768 15.1838 10.755C14.94 10.5112 14.94 10.1156 15.1838 9.87091L15.8091 9.24559C16.0529 9.00184 16.4485 9.00184 16.6932 9.24559C16.9369 9.48935 16.9369 9.88497 16.6932 10.1297L16.0679 10.755C15.945 10.8768 15.7847 10.9378 15.6254 10.9378Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2501 10.9383C11.0897 10.9383 10.9304 10.8773 10.8085 10.7555L10.1832 10.1302C9.93943 9.8864 9.93943 9.49078 10.1832 9.24609C10.4269 9.00234 10.8226 9.00234 11.0672 9.24609L11.6926 9.8714C11.9363 10.1152 11.9363 10.5108 11.6926 10.7555C11.5697 10.8773 11.4104 10.9383 11.2501 10.9383Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4372 12.4209C22.3528 12.2766 22.1991 12.1875 22.0313 12.1875H11.8753C9.46312 12.1875 7.5 14.1506 7.5 16.5628C7.5 18.975 9.46312 20.9381 11.8753 20.9381C14.2875 20.9381 16.2506 18.975 16.2506 16.5628V15.4688C16.2506 15.3825 16.3209 15.3122 16.4072 15.3122H19.6941C20.5331 15.3122 21.3131 14.8603 21.7294 14.1309L22.4391 12.8878C22.5216 12.7434 22.5206 12.5653 22.4372 12.4209ZM11.8753 19.0622C10.4944 19.0622 9.375 17.9428 9.375 16.5619C9.375 15.1819 10.4944 14.0625 11.8753 14.0625C13.2563 14.0625 14.3756 15.1819 14.3756 16.5628C14.3756 17.9428 13.2563 19.0622 11.8753 19.0622Z"
});

function SvgWhistle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhistle);
export default __webpack_public_path__ + "static/media/whistle.8ca87ad0.svg";
export { ForwardRef as ReactComponent };